(ns kyber.components.composite.videojs-player
  (:require [re-frame.core :as re-frame]
            [reagent.core :as reagent]

            [kyber.constants :refer [html5-media-player-events]]
            [kyber.utils :as ku]
            [kyber.styles.core :refer [styles->classes]]
            [kyber.i18n.core :as i18n]))

(def classes
  (styles->classes
   {:player-container
    {:max-width "100%"
     ;; !important required b/c of Video.js overrides
     :width "100% !important"
     :height "100% !important"
     "& video"
     {:width "100%"
      :height "100%"}}}))

(defn- handle-volume
  [player-key]
  (let [show-volume-controls
        (:show-volume-controls
         @(re-frame/subscribe [:media-player/player-attributes player-key]))]
    (when (true? show-volume-controls)
      (re-frame/dispatch
       [:media-player/toggle-volume-controls {:player-key player-key
                                              :action :close}]))))

(defn- handle-space-bar
  [player-key active-resource-key]
  (fn [e]
    (when (= "Space" (.-code e))
      (let [{:keys [player-state]}
            @(re-frame/subscribe [:media-player/player-attributes player-key])
            {:keys [show-activity-splash
                    show-note-widget
                    show-resource-library
                    show-learning-stream
                    designed-moment-active]}
            (or (when (= :main-activity player-key)
                  @(re-frame/subscribe [:activity/activity]))
                false)

            active-resource
            @(re-frame/subscribe [active-resource-key])]

        (when (and (false? show-activity-splash)
                   (false? show-note-widget)
                   (false? show-resource-library)
                   (false? show-learning-stream)
                   (true? (empty? designed-moment-active))
                   (nil? active-resource))
          (cond
            (= :play player-state)
            (re-frame/dispatch-sync
             [:media-player/pause-media
              {:player-key player-key}])

            (= :pause player-state)
            (re-frame/dispatch-sync
             [:media-player/play-media
              {:player-key player-key}])))))))

(defn attach-events-listeners!
  [{:keys [^js player player-key context space-bar-fn volume-click-fn]}]
  ;; Attach spacebar event
  (when (false? (ku/is-mobile?))
    (.addEventListener js/document "keyup" space-bar-fn))

  (.addEventListener js/document "mouseup" volume-click-fn)

  ;; Attach video player events
  (doseq [event-name html5-media-player-events]
    (.on player
         (name event-name)
         #(let [dispatch-key (keyword "media-player" (name event-name))]
            (re-frame/dispatch [dispatch-key {:player-key player-key
                                              :context context}])))))

(defn videojs-player
  [{:keys [player-key]}
   {:keys [active-resource-key] :or {active-resource-key
                                     :resource-library/active-resource}}]
  (let [!ref            (atom nil)
        !player         (atom nil)
        space-bar-fn    (handle-space-bar player-key active-resource-key)
        volume-click-fn (partial handle-volume player-key)

        browser-not-supported-message
        [:p {:class "vjs-no-js"}
         (i18n/t* ::no-support)
         [:a {:href   "http://videojs.com/html5-video-support/"
              :target "_blank"}
          (i18n/t* ::no-support-link)]]]

    (reagent/create-class
     {:component-did-mount
      (fn [this]
        (let [{:keys [sources player-key options resource-uuid]}
              (reagent/props this)

              ecid (ku/gen-cid)

              player
              (.videojs js/window
                        @!ref
                        (clj->js
                         {:controls false
                          ;; /brightcove/videojs-flashls-source-handler#usage
                          :flash    {:swf "/vendor/video-js/video-js.swf"}}))
              context
              {:ecid ecid}]

          (attach-events-listeners! {:player          player
                                     :player-key      player-key
                                     :context         context
                                     :space-bar-fn    space-bar-fn
                                     :volume-click-fn volume-click-fn})
          (reset! !player player)

          (re-frame/dispatch [:analytics/set-event-context
                              {:ecid ecid
                               :event-context
                               {:src           (get-in sources [0 :src])
                                :player-key    player-key
                                :resource-uuid resource-uuid}}])

          (re-frame/dispatch-sync [:media-player/initialize
                                   {:player-key player-key
                                    :player     player
                                    :context    context
                                    :options    options}])))

      :component-will-unmount
      (fn [this]
        (let [{:keys [player-key]}
              (reagent/props this)]

          (when (false? (ku/is-mobile?))
            (.removeEventListener js/document "keyup" space-bar-fn))

          (.removeEventListener js/document "mouseup" volume-click-fn)

          (re-frame/dispatch [:media-player/teardown player-key])))

      :reagent-render
      (fn [{:keys [sources element-tag player-key]
            :or   {element-tag :video}
            :as   props}]

        (into [element-tag
               (-> props
                   (dissoc :sources
                           :player-key
                           :class
                           :element-tag
                           :activity-uuid
                           :resource-uuid
                           :poster
                           :options)
                   (assoc :playsInline true)
                   (assoc :ref #(reset! !ref %))
                   (assoc :on-click #(re-frame/dispatch-sync
                                      [:media-player/pause-media
                                       {:player-key player-key}]))
                   (update :class #(into [(:player-container classes)] %)))]
              (conj (map (fn [source-props]
                           [:source source-props])
                         sources)
                    browser-not-supported-message)))})))
